import {Helmet, HelmetTags} from 'react-helmet-async';
import React from 'react';

import {useHostName} from 'presentation/hooks/useHostName';
import {useSinalLink} from './useSinaLink';
import {useHandTalk} from './useHandTalk';
import {useMicrosoftClarity} from './useMicrosoftClarity';
import {CookieLaw} from './cookieLaw';

export const Plugins = () => {
	const isOnProd = window.location.hostname.indexOf('com.br') > -1;
	const {sinalLinkScript, handleOnSinalLinkLoad} = useSinalLink();
	const {isClinipam, isNotredameSaude} = useHostName();

	const {handTalkScript, handleOnHandTalkLoad} = useHandTalk();
	const {microsoftClarityScript, handleOnMicrosoftClarityLoad} = useMicrosoftClarity();

	const pluginsScripts = [
		{script: sinalLinkScript, onLoad: handleOnSinalLinkLoad},
		{script: microsoftClarityScript, onLoad: handleOnMicrosoftClarityLoad},
		{script: handTalkScript, onLoad: handleOnHandTalkLoad},
	];

	const handleScriptInject = ({scriptTags}: HelmetTags) => {
		if (scriptTags) {
			scriptTags.forEach((tag, index) => {
				if (!isOnProd) {
					pluginsScripts.pop();
				}
				const scriptTag = tag;
				scriptTag.onload = pluginsScripts[index]?.onLoad;
			});
		}
	};

	return (
		<>
			<Helmet
				script={pluginsScripts.map(plugin => plugin.script)}
				onChangeClientState={(newState, addedTags) => handleScriptInject(addedTags)}
			/>
			{isOnProd && !isClinipam && !isNotredameSaude && <CookieLaw />}
		</>
	);
};
